import axios from "axios";
import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";

const CoupanCreate = () => {

  const initialFormState = {
  coupon_name: "",
  coupon_code: "",
  description: "",
  apply_on: "all",
  type: "price",
  value: "",
  min_order: "",
  max_discount: "",
  product_ids: [],
  start_date: "",
  expiry_date: "",
  status: "active",
};


  const [CoupanUser, setCoupanUser] = useState(initialFormState);
  const [products, setProducts] = useState([]);
  const [loadingProducts, setLoadingProducts] = useState(false);
  const navigate = useNavigate();

  


//   /* 🔹 Fetch Products from API */
  const fetchProducts = async () => {
    setLoadingProducts(true);
    try {
      const res = await axios.get(
        "https://cyberathon.com/multivendor/index.php/Api/Master_controller/list_create_product"
      );

      if (res.data?.status) {
        setProducts(res.data.data || []);
      }
    } catch (error) {
      toast.error("Failed to load products");
    }
  };

  useEffect(() => {
    fetchProducts();
  }, []);

  /* 🔹 Handle Inputs */
  const handleChange = (e) => {
    const { name, value } = e.target;
    setCoupanUser({ ...CoupanUser, [name]: value });
  };

  const handleProductSelect = (e) => {
    const selectedIds = Array.from(
      e.target.selectedOptions,
      (opt) => opt.value
    );

    setCoupanUser({
      ...CoupanUser,
      product_ids: selectedIds,
    });
  };

  const handleSubmit = async (e) => {
  e.preventDefault();

  if (!CoupanUser.coupon_name || !CoupanUser.coupon_code || !CoupanUser.value) {
    toast.error("Coupon name, code and value are required");
    return;
  }

  if (
    CoupanUser.apply_on === "products" &&
    CoupanUser.product_ids.length === 0
  ) {
    toast.error("Please select at least one product");
    return;
  }

  const payload = {
    coupon_name: CoupanUser.coupon_name,
    coupon_code: CoupanUser.coupon_code,
    description: CoupanUser.description,
    apply_coupon_on:
      CoupanUser.apply_on === "products" ? "product" : "order",
    discount_type:
      CoupanUser.type === "discount" ? "percentage" : "price",
    discount_value: CoupanUser.value,
    minimum_order_value: CoupanUser.min_order,
    start_date: CoupanUser.start_date,
    expiry_date: CoupanUser.expiry_date,
    status: CoupanUser.status,
    product_ids: CoupanUser.product_ids,
  };

  try {
    const res = await axios.post(
      "https://cyberathon.com/multivendor/index.php/Api/Master_controller/add_new_coupon",
      payload,
      { headers: { "Content-Type": "application/json" } }
    );

    if (res.data?.success === "1") {
      toast.success("Coupon created successfully");
      navigate("/Coupon-list");
    } else {
      toast.error(res.data?.message || "Failed to create coupon");
    }
  } catch (error) {
    console.error(error);
    toast.error("Something went wrong");
  }
};


  return (
    <div className="page-content">
      <div className="container-fluid">
        <div className="row">
          <div className="col-12">
            <div className="page-title-box">
              <h4 className="mb-0 fw-semibold">Create Coupan</h4>
              <ol className="breadcrumb mb-0">
                <li className="breadcrumb-item">
                  <a href="javascript:void(0);">Coupan</a>
                </li>
                <li className="breadcrumb-item active">Create Coupan</li>
              </ol>
            </div>
          </div>
        </div>

        <div className="row">
          <div className="col-xl-9 col-lg-8 ">
            <form onSubmit={handleSubmit}>
              <div className="card">
                <div className="card-header">
                  <h4 className="card-title">General Information</h4>
                </div>
                <div className="card-body">
                  <div className="row">

                    <div className="col-md-6 mb-3">
                <label className="form-label">Coupon Name</label>
                <input
                      className="form-control"
                      name="coupon_name"
                      value={CoupanUser.coupon_name}
                      onChange={handleChange}
                    />

              </div>

                    <div className="col-md-6 mb-3">
                <label className="form-label">Coupon Code</label>
                <input
  className="form-control"
  name="coupon_code"
  value={CoupanUser.coupon_code}
  onChange={handleChange}
/>

              </div>

              <div className="col-md-6 mb-3">
                <label className="form-label">Description</label>
                <input
  className="form-control"
  name="description"
  value={CoupanUser.description}
  onChange={handleChange}
/>

              </div>

              {/* Apply On */}
              <div className="col-md-6 mb-3">
                <label className="form-label">Apply Coupon On</label>
                <select
                  className="form-select"
                  name="apply_on"
                  value={CoupanUser.apply_on}
                  onChange={handleChange}
                >
                  <option value="all">All Products</option>
                  <option value="products">Selected Products</option>
                </select>
              </div>

              {/* Product Multi Select */}
              {CoupanUser.apply_on === "products" && (
                <div className="col-md-12 mb-3">
                  <label className="form-label">Select Products</label>

                  {loadingProducts ? (
                    <div className="form-control">Loading products...</div>
                  ) : (
                    <select
                      multiple
                      className="form-select"
                      onChange={handleProductSelect}
                    >
                      {products.map((p) => (
                        <option key={p.product_id} value={p.product_id}>
                          {p.product_name}
                          {p.model_name ? ` (${p.model_name})` : ""}
                        </option>
                      ))}
                    </select>
                  )}

                  <small className="text-muted">
                    Hold Ctrl (Windows) / Cmd (Mac) to select multiple
                  </small>
                </div>
              )}

              {/* Discount Type */}
              <div className="col-md-6 mb-3">
                <label className="form-label">Discount Type</label>
                <select
                  className="form-select"
                  name="type"
                  value={CoupanUser.type}
                  onChange={handleChange}
                >
                  <option value="price">Flat Price (₹)</option>
                  <option value="discount">Percentage (%)</option>
                </select>
              </div>

              {/* Value */}
              <div className="col-md-6 mb-3">
                <label className="form-label">Discount Value</label>
                <input
                  type="number"
                  className="form-control"
                  name="value"
                  value={CoupanUser.value}
                  onChange={handleChange}
                />
              </div>

              {/* Min Order */}
              <div className="col-md-6 mb-3">
                <label className="form-label">Minimum Order Value</label>
                <input
                  type="number"
                  className="form-control"
                  name="min_order"
                  value={CoupanUser.min_order}
                  onChange={handleChange}
                />
              </div>

              {/* Max Discount (only for %) */}
              {CoupanUser.type === "discount" && (
                <div className="col-md-6 mb-3">
                  <label className="form-label">Max Discount (₹)</label>
                  <input
                    type="number"
                    className="form-control"
                    name="max_discount"
                    value={CoupanUser.max_discount}
                    onChange={handleChange}
                  />
                </div>
              )}

              {/* start date */}
              <div className="col-md-6 mb-3">
                <label className="form-label">Start Date</label>
                <input
  type="date"
  className="form-control"
  name="start_date"
  value={CoupanUser.start_date}
  onChange={handleChange}
/>

              </div>

              {/* Expiry */}
              <div className="col-md-6 mb-3">
                <label className="form-label">Expiry Date</label>
                <input
                  type="date"
                  className="form-control"
                  name="expiry_date"
                  value={CoupanUser.expiry_date}
                  onChange={handleChange}
                />
              </div>

              {/* Status */}
              <div className="col-md-6 mb-3">
                <label className="form-label">Status</label>
                <select
                  className="form-select"
                  name="status"
                  value={CoupanUser.status}
                  onChange={handleChange}
                >
                  <option value="active">Active</option>
                  <option value="inactive">Inactive</option>
                </select>
              </div>
                  </div>
                </div>
              </div>

              <div className="p-3 bg-light mb-3 rounded">
                <div className="row justify-content-end g-2">
                  <div className="col-lg-2">
                    <button
                      type="submit"
                      className="btn btn-outline-secondary w-100"
                    >
                      Save Change
                    </button>
                  </div>
                  <div className="col-lg-2">
                    <Link to="/Coupan-list" className="btn btn-primary w-100">
                      Cancel
                    </Link>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>

      <footer className="footer">
        <div className="container-fluid">
          <div className="row">
            <div className="col-12 text-center">
              © Venton. Crafted by{" "}
              <iconify-icon
                icon="iconamoon:heart-duotone"
                className="fs-18 align-middle text-danger"
              />{" "}
              <a href="#" className="fw-bold footer-text" target="_blank">
                Techzaa
              </a>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default CoupanCreate;


// import React, { useEffect, useState } from "react";
// import axios from "axios";
// import { toast } from "react-toastify";

// const CoupanCreate = () => {
//   const [products, setProducts] = useState([]);
//   const [loadingProducts, setLoadingProducts] = useState(false);

//   const [CoupanUser, setCoupanUser] = useState({
//     coupon_code: "",
//     type: "price",
//     value: "",
//     min_order: "",
//     max_discount: "",
//     apply_on: "all",
//     product_ids: [],
//     expiry_date: "",
//     status: "active",
//   });

//   /* 🔹 Fetch Products from API */
//   const fetchProducts = async () => {
//     try {
//       setLoadingProducts(true);
//       const res = await axios.get(
//         "https://cyberathon.com/multivendor/index.php/Api/Master_controller/list_create_product"
//       );

//       if (res.data?.status) {
//         setProducts(res.data.data || []);
//       }
//     } catch (error) {
//       toast.error("Failed to load products");
//     } finally {
//       setLoadingProducts(false);
//     }
//   };

//   useEffect(() => {
//     fetchProducts();
//   }, []);

//   /* 🔹 Handle Inputs */
//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     setCoupanUser({ ...CoupanUser, [name]: value });
//   };

//   const handleProductSelect = (e) => {
//     const selectedIds = Array.from(
//       e.target.selectedOptions,
//       (opt) => opt.value
//     );

//     setCoupanUser({
//       ...CoupanUser,
//       product_ids: selectedIds,
//     });
//   };

//   /* 🔹 Submit */
//   const handleSubmit = (e) => {
//     e.preventDefault();

//     if (!CoupanUser.coupon_code || !CoupanUser.value) {
//       toast.error("Coupon code and value are required");
//       return;
//     }

//     if (
//       CoupanUser.apply_on === "products" &&
//       CoupanUser.product_ids.length === 0
//     ) {
//       toast.error("Please select at least one product");
//       return;
//     }

//     console.log("FINAL COUPON PAYLOAD:", CoupanUser);

//     toast.success("Coupon created successfully!");
//   };

//   return (
//     <div className="container" style={{marginLeft:"100px"}}>
//       <div className="card shadow-sm">
//         <div className="card-header bg-primary text-white">
//           <h5 className="mb-0">Add Product Based Coupon</h5>
//         </div>

//         <div className="card-body">
//           <form onSubmit={handleSubmit}>
//             <div className="row">

//               {/* Coupon Code */}
//               <div className="col-md-6 mb-3">
//                 <label className="form-label">Coupon Code</label>
//                 <input
//                   className="form-control"
//                   name="coupon_code"
//                   value={CoupanUser.coupon_code}
//                   onChange={handleChange}
//                   placeholder="REALME20"
//                 />
//               </div>

//               {/* Apply On */}
//               <div className="col-md-6 mb-3">
//                 <label className="form-label">Apply Coupon On</label>
//                 <select
//                   className="form-select"
//                   name="apply_on"
//                   value={CoupanUser.apply_on}
//                   onChange={handleChange}
//                 >
//                   <option value="all">All Products</option>
//                   <option value="products">Selected Products</option>
//                 </select>
//               </div>

//               {/* Product Multi Select */}
//               {CoupanUser.apply_on === "products" && (
//                 <div className="col-md-12 mb-3">
//                   <label className="form-label">Select Products</label>

//                   {loadingProducts ? (
//                     <div className="form-control">Loading products...</div>
//                   ) : (
//                     <select
//                       multiple
//                       className="form-select"
//                       onChange={handleProductSelect}
//                     >
//                       {products.map((p) => (
//                         <option key={p.product_id} value={p.product_id}>
//                           {p.product_name}
//                           {p.model_name ? ` (${p.model_name})` : ""}
//                         </option>
//                       ))}
//                     </select>
//                   )}

//                   <small className="text-muted">
//                     Hold Ctrl (Windows) / Cmd (Mac) to select multiple
//                   </small>
//                 </div>
//               )}

//               {/* Discount Type */}
//               <div className="col-md-6 mb-3">
//                 <label className="form-label">Discount Type</label>
//                 <select
//                   className="form-select"
//                   name="type"
//                   value={CoupanUser.type}
//                   onChange={handleChange}
//                 >
//                   <option value="price">Flat Price (₹)</option>
//                   <option value="discount">Percentage (%)</option>
//                 </select>
//               </div>

//               {/* Value */}
//               <div className="col-md-6 mb-3">
//                 <label className="form-label">Discount Value</label>
//                 <input
//                   type="number"
//                   className="form-control"
//                   name="value"
//                   value={CoupanUser.value}
//                   onChange={handleChange}
//                 />
//               </div>

//               {/* Min Order */}
//               <div className="col-md-6 mb-3">
//                 <label className="form-label">Minimum Order Value</label>
//                 <input
//                   type="number"
//                   className="form-control"
//                   name="min_order"
//                   value={CoupanUser.min_order}
//                   onChange={handleChange}
//                 />
//               </div>

//               {/* Max Discount (only for %) */}
//               {CoupanUser.type === "discount" && (
//                 <div className="col-md-6 mb-3">
//                   <label className="form-label">Max Discount (₹)</label>
//                   <input
//                     type="number"
//                     className="form-control"
//                     name="max_discount"
//                     value={CoupanUser.max_discount}
//                     onChange={handleChange}
//                   />
//                 </div>
//               )}

//               {/* Expiry */}
//               <div className="col-md-6 mb-3">
//                 <label className="form-label">Expiry Date</label>
//                 <input
//                   type="date"
//                   className="form-control"
//                   name="expiry_date"
//                   value={CoupanUser.expiry_date}
//                   onChange={handleChange}
//                 />
//               </div>

//               {/* Status */}
//               <div className="col-md-6 mb-3">
//                 <label className="form-label">Status</label>
//                 <select
//                   className="form-select"
//                   name="status"
//                   value={CoupanUser.status}
//                   onChange={handleChange}
//                 >
//                   <option value="active">Active</option>
//                   <option value="inactive">Inactive</option>
//                 </select>
//               </div>

//             </div>

//             <div className="text-end">
//               <button className="btn btn-success px-4">
//                 Save Coupon
//               </button>
//             </div>
//           </form>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default CoupanCreate;
